import * as React from 'react';
import {
  DialogProps,
  Typography,
  Grid,
  TextField,
  MenuItem,
} from '@material-ui/core';
import { FormDialog, SnackbarContext } from 'components';
import { LocationJobType, Location } from 'interfaces';
import { LocationService } from 'services/LocationService';

interface Props {
  dialogProps: DialogProps;
  loading: boolean;
  jobTypeId: number;
  jobTypeLocationList: LocationJobType[];
  locationList: Location[];
  refresh: () => void;
}

export const AddJobTypeLocationDialog: React.FC<Props> = ({
  dialogProps,
  loading,
  jobTypeId,
  jobTypeLocationList,
  locationList,
  refresh,
}) => {
  const [locationId, setLocation] = React.useState<number>();
  const snackbar = React.useContext(SnackbarContext);

  const list =
    jobTypeLocationList.length > 0
      ? locationList
          .filter(
            (type) =>
              !jobTypeLocationList.some((obj) => obj.location?.id === type.id),
          )
          .map((type) => type)
      : locationList;

  return (
    <FormDialog
      title={
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <Typography variant="h6">Add Location to this Job Type</Typography>
        </div>
      }
      submitText="Add Location"
      onSubmit={submit}
      loading={loading}
      dialogProps={dialogProps}
    >
      <Grid container>
        <Grid item xs={12}>
          <TextField
            select
            label="Location"
            helperText="Please select location"
            fullWidth
            required
            onChange={(e) => {
              setLocation(+e.target.value);
            }}
            name="user_type_id"
            value={locationId}
          >
            {list.map((type: Location, key) => (
              <MenuItem key={key} value={type.id}>
                {type.name}
              </MenuItem>
            ))}
          </TextField>
        </Grid>
      </Grid>
    </FormDialog>
  );

  function submit(e: React.FormEvent<HTMLFormElement>) {
    try {
      if (!locationId) {
        throw new Error('Empty Jop Type id');
      }
      LocationService.postNewLocationJobType(locationId, jobTypeId);
      refresh();

      if (dialogProps.onClose) {
        dialogProps.onClose(e);
      }
      snackbar.open('Location for this job type has been linked successfully.');
    } catch (error) {
      snackbar.error(error);
    }
  }
};
